@if (isSlipsDetailsOpen) {
    <label>{{ messages.hide }}</label>
    <i class="theme-up"></i>
}
@if (!isSlipsDetailsOpen) {
    <label>{{ messages.show }}</label>
    <i class="theme-down"></i>
}
